import "./style.scss";

import appStoreImg from "./images/app-store.png";
import playMarketImg from "./images/play-market.png";

export default function AppsPage() {
  return (
    <div className="apps-page">
      <div className="apps-page__grid">
        <div className="apps-page__card">
          <h1 className="apps-page__title">Zim Owner</h1>

          <div className="apps-page__stores">
            <a
              href="https://apps.apple.com/uz/app/zim-owner/id6444340411"
              target="_blank"
              rel="noreferrer"
              className="store-btn store-btn--apple"
            >
              <div className="store-btn__icon">
                <img src={appStoreImg} alt="App Store" />
              </div>
              <div className="store-btn__lines">
                <span className="store-btn__small">Yuklab olish</span>
                <span className="store-btn__big">App Store</span>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=uz.zimowner"
              target="_blank"
              rel="noreferrer"
              className="store-btn store-btn--google"
            >
              <div className="store-btn__icon">
                <img src={playMarketImg} alt="Google Play" />
              </div>
              <div className="store-btn__lines">
                <span className="store-btn__small">Yuklab olish</span>
                <span className="store-btn__big">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
